import { VideoCreatorStoreProvider } from '@src/stores-v2';
import { BRollUploadProvider } from './BRollUploadContext';
import BRollUploadPage from './BRollUploadPage';

const BRollUpload = () => {
  return (
    <VideoCreatorStoreProvider>
      <BRollUploadProvider>
        <BRollUploadPage />
      </BRollUploadProvider>
    </VideoCreatorStoreProvider>
  );
};

export default BRollUpload;
